import BaseComponent from '@/js/core/BaseComponent'
import { MediaQ } from '@/js/constants'

export default class MatchMedia extends BaseComponent {
  breakpoints = {
    SM: window.matchMedia(`(max-width: ${MediaQ.SM-1}px)`),
    MD: window.matchMedia(`(min-width: ${MediaQ.MD}px) and (max-width: ${MediaQ.LG-1}px)`),
    LG: window.matchMedia(`(min-width: ${MediaQ.LG}px) and (max-width: ${MediaQ.XL-1}px)`),
    XL: window.matchMedia(`(min-width: ${MediaQ.XL}px)`),
  }

  state = {
    ...this.state,
    breakpointSMMatches: undefined,
    breakpointMDMatches: undefined,
    breakpointLGMatches: undefined,
    breakpointXLMatches: undefined,
  }

  addMatchMediaListeners (breakpoint) {
    try {
      breakpoint.addEventListener('change', this.onBreakpointChange.bind(this))
    } catch (error) {
      try {
        breakpoint.addListener(this.onBreakpointChange.bind(this))
      } catch (error) {
        console.error(error);
      }
    }
  }

  onBreakpointChange () {
    for (const key in this.breakpoints) {
      const breakpoint = this.breakpoints[key]
      this.setState(() => ({
        [`breakpoint${key}Matches`]: breakpoint.matches,
      }))
    }
  }

  mounted () {
    super.mounted()
    this.onBreakpointChange()
    for (const key in this.breakpoints) {
      const breakpoint = this.breakpoints[key]
      this.addMatchMediaListeners(breakpoint)
    }
  }
}